import { Component, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { NotificationService } from "../notification.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "app-view-notification-history",
  templateUrl: "./view-notification-history.component.html",
  styleUrls: ["./view-notification-history.component.sass"],
})
export class ViewNotificationHistoryComponent implements OnInit {
  notifications: any[] = [];

  selectedImage = "";
  page = 1;

  limit = 10;

  totalRecords = 0;

  totalPages = 0;

  hasPreviousPage = false;

  hasNextPage = false;

  constructor(
    private notificationService: NotificationService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getNotificationHistory();
  }

  getNotificationHistory(): void {
    this.spinner.show();
    let data = {
      page: this.page,
      limit: this.limit,
    };
    this.notificationService
      .getNotificationHistory(data)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (response: any) => {
          if (response.statusCode === 200) {
            this.notifications = response.data;

            this.totalRecords = response.totalRecords;

            this.totalPages = response.totalPages;

            this.hasPreviousPage = response.hasPreviousPage;

            this.hasNextPage = response.hasNextPage;
          } else {
            this.toastr.error(response.message);
          }
        },

        error: () => {
          this.toastr.error("Unable to load notification history.");
        },
      });
  }

  changePage(page: number): void {
    this.page = page;

    this.getNotificationHistory();
  }

  openImage(image: string): void {
    this.selectedImage = image;
  }

  closeImage(): void {
    this.selectedImage = "";
  }
}
